var ImportDataModule = (function () {
    function ImportDataModule() {
    }
    return ImportDataModule;
}());
export { ImportDataModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data.module.ts.pre-build-optimizer.js